import { useMutation, useQueryClient } from "@tanstack/react-query";
import { forceDeleteSchool as apiForceDeleteSchool } from "../../api/apiSchools";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useForceDeleteSchool() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: forceDeleteSchool, isPending: isForceDelete, data: results, error } = useMutation({
        mutationFn: (id) => apiForceDeleteSchool(id),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["schools"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { forceDeleteSchool, isForceDelete, error, results };
}
